
export default {
  components: {
    Dialog: () => import('primevue/dialog'),
    Checkbox: () => import('primevue/checkbox'),
    InputText: () => import('primevue/inputtext'),
    Button: () => import('primevue/button'),
    Textarea: () => import('primevue/textarea')
  },
  props: {
    cid: { type: String, default: '' },
    display: { type: Boolean, default: false },
    campaign: { type: Object, default: () => ({}) },
    query: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      sharedLink: '',
      copied: false,
      localDisplay: this.display,
      step: 1,
      terms1: false,
      terms2: false,
      orpName: '',
      orpEmail: '',
      orpMessage: '',
      submitTried: false,
      addMessage: false,
      errorTitle: '',
      error: ''
    }
  },
  computed: {
    isLoggedWithConsent() {
      return this.$auth?.loggedIn && this.$auth?.user?.p2p_agree
    },
    getCities() {
      const cities = this.campaign.city ? this.campaign.city.split('|') : []
      return cities.length > 1 ? cities.join(', ') : cities[0]
    },
    countCities() {
      return this.campaign.city ? this.campaign.city.split(',').length : 0
    }
  },
  watch: {
    display(val) {
      this.localDisplay = val
    },
    localDisplay(val) {
      this.$emit('update:display', val)
      if (val && this.step === 1) {
        this.trackStep('flusso_orp', 'start')
        this.trackStep('info', 'start')
      }
    }
  },
  beforeMount() {
    if (process.client) {
      const pendingOrp = sessionStorage.getItem('pending_orp_suggestion')
      if (pendingOrp) {
        const orpData = JSON.parse(pendingOrp)
        if (orpData?.cid) {
          this.orpName = orpData.name
          this.orpEmail = orpData.email
          this.orpMessage = orpData.message
          this.suggestCampaign()
        }
      }
    }
  },
  methods: {
    /**
     * Funzione centralizzata per il tracking - semplifica e unifica la gestione
     * @param {string} stepName - Nome dello step
     * @param {string} stepStage - Fase dello step (start/end)
     * @param {string} actionStep - Azione specifica (next/exit/copy_link/etc.)
     */
    trackStep(stepName, stepStage, actionStep = '') {
      this.$gtm.push({
        event: 'orp_program_v2',
        event_data: {
          step_name: stepName,
          step_stage: stepStage,
          action_step: actionStep,
          logged: this.$auth?.loggedIn,
          company_name: this.campaign?.company?.co_name,
          job_application_name: this.campaign?.title,
          job_application_place: this.campaign?.city,
          is_stage: this.campaign?.contract_type === 8,
          verified: this.campaign?.verified,
          orp: this.campaign.p2p,
          orp_value: Number(this.campaign.unlockamount),
          page_url: this.$router.currentRoute.fullPath,
          page_title: (typeof document !== 'undefined' && document.title) ? document.title : 'CVing'
        }
      })
    },

    getCurrentStepName() {
      const stepNames = {
        1: 'info',
        2: 'invito',
        3: 'terms'
      }
      return stepNames[this.step] || ''
    },

    goToStep(targetStep) {
      const currentStepName = this.getCurrentStepName()
      this.trackStep(currentStepName, 'end', 'next')

      this.step = targetStep

      const newStepName = this.getCurrentStepName()
      this.trackStep(newStepName, 'start')
    },

    closeAndTrack() {
      const currentStepName = this.getCurrentStepName()

      if (this.step <= 3) {
        this.trackStep(currentStepName, 'end', 'exit')
      }

      this.reset()
    },

    showTermsOrSuggest() {
      this.submitTried = false
      const emailValid = this.validateEmail(this.orpEmail)

      if (this.orpName && emailValid) {
        if (this.isLoggedWithConsent) {
          this.trackStep('invito', 'end', 'next')
          this.suggestCampaign()
        } else {
          this.trackStep('invito', 'end', 'next')
          this.step = 3
          this.trackStep('terms', 'start')
        }
      } else {
        this.submitTried = true
      }
    },

    async copyLink() {
      try {
        this.$nuxt.$loading?.start()

        if (!this.sharedLink) {
          const response = await this.$axios.post('/proxysbapi/auth/sharedlink', { cid: this.cid })
          this.sharedLink = response.data.sharedLink
        }

        await this.copyToClipboard(this.sharedLink)
        this.copied = true
        this.trackStep('invito', 'end', 'copy_link')
      } catch (error) {
        this.handleError(error)
      } finally {
        this.$nuxt.$loading?.finish()
        setTimeout(() => {
          this.copied = false
        }, 1500)
      }
    },

    async copyToClipboard(text) {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        // Fallback per browser più vecchi
        const tmpTextField = document.createElement('textarea')
        tmpTextField.textContent = text
        tmpTextField.style.cssText = 'position:absolute; right:200%;'
        document.body.appendChild(tmpTextField)
        tmpTextField.select()
        tmpTextField.setSelectionRange(0, 99999)
        document.execCommand('copy')
        tmpTextField.remove()
      }
    },

    validateEmail(email) {
      if (!email) { return false }

      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return emailRegex.test(email.toLowerCase())
    },

    async updateTerms() {
      this.$nuxt.$loading?.start()
      this.trackStep('terms', 'end', 'next')

      try {
        if (this.$auth?.loggedIn && !this.$auth?.user?.p2p_agree) {
          await this.$axios.post('/proxysbapi/auth/user/p2pagreement')
          const updatedUser = { ...this.$auth.user, p2p_agree: true }
          this.$auth.setUser(updatedUser)

          if (this.isLoggedWithConsent) {
            await this.suggestCampaign()
          }
        } else {
          // Salva in sessionStorage per recuperare dopo login/signup
          if (process.client) {
            sessionStorage.setItem('pending_orp_suggestion', JSON.stringify({
              cid: this.cid,
              name: this.orpName,
              email: this.orpEmail,
              message: this.addMessage ? this.orpMessage : '',
              campaign: this.campaign,
              query: this.query
            }))
          }
          this.reset()
          // url dello slug dove voglio tornare dopo la login
          // this.$auth.redirect = this.$route.fullPath
          this.$auth.$storage.setUniversal('redirect', this.$route.fullPath)
          // Redirect a /suggest - Nuxt Auth intercetterà e reindirizzerà a login,
          // poi dopo il login tornerà automaticamente a /suggest
          this.$router.push(this.localePath('login'))
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.$nuxt.$loading?.finish()
      }
    },

    async suggestCampaign() {
      if (!this.cid) { return }

      this.$nuxt.$loading?.start()

      const params = {
        nome: this.orpName,
        email: this.orpEmail,
        note: this.orpMessage,
        cid: this.cid
      }

      try {
        await this.$axios.post('/proxysbapi/auth/referral/invitation', params)
        this.step = 4
        this.localDisplay = true

        this.trackStep('flusso_orp', 'end')
      } catch (error) {
        this.handleError(error)
        this.trackStep('flusso_orp', 'error')
        this.localDisplay = true
      } finally {
        this.$nuxt.$loading?.finish()
        // Pulisci sessionStorage dopo suggerimento completato
        if (process.client) {
          sessionStorage.removeItem('pending_orp_suggestion')
        }
      }
    },

    handleError(error) {
      const errorMessages = {
        'P2P-001': 'error.alreadyApplied',
        'P2P-002': 'error.alreadyApplied',
        'P2P-034': 'error.alreadyApplied',
        'P2P-033': 'error.cannotInviteYourself'
      }

      const messageCode = error?.response?.data?.messageCode

      if (messageCode && errorMessages[messageCode]) {
        this.errorTitle = messageCode === 'P2P-033'
          ? this.$t('error.attention').toString()
          : this.$t('error.alreadyAppliedTitle')
        this.error = this.$t(errorMessages[messageCode]).toString()
        this.step = 5
      } else if (messageCode) {
        this.errorTitle = this.$t('error.generic')
        this.step = 5
      }

      if (this.$auth.loggedIn) {
        this.$sentry.setTag('email', this.$auth.user.email)
      }
      this.$sentry.captureException(error)
    },

    reset() {
      Object.assign(this.$data, {
        submitTried: false,
        errorTitle: '',
        addMessage: false,
        error: '',
        terms1: false,
        terms2: false,
        orpName: '',
        orpEmail: '',
        orpMessage: '',
        step: 1
      })
    },

    inviteOthers() {
      this.resetFormData()
      this.step = 2
      this.trackStep('flusso_orp', 'start')
    },

    resetFormData() {
      Object.assign(this.$data, {
        submitTried: false,
        errorTitle: '',
        addMessage: false,
        error: '',
        terms1: false,
        terms2: false,
        orpName: '',
        orpEmail: '',
        orpMessage: ''
      })
    },

    backToRadar() {
      this.reset()
      this.$router.push(this.localePath({
        name: 'radar',
        query: { ea: '0', p: '1', orp: 'true' }
      }))
    },

    goToPersonalArea() {
      const isMobile = process.browser ? window.innerWidth < 768 : false
      const profileLink = isMobile ? 'user-settings' : 'user-settings-profile'

      this.$router.push({ path: this.localePath(profileLink) })
    }
  }
}
